import banImg1 from "../../assets/images/services/data/data-banner.webp";
import banImg2 from "../../assets/images/services/data/data-inro.webp";
import features01 from "../../assets/images/services/data/data-featu-01.webp"
import features02 from "../../assets/images/services/data/data-featu-02.webp"
import features03 from "../../assets/images/services/data/data-featu-03.webp"
import features04 from "../../assets/images/services/data/data-featu-04.webp"
import features05 from "../../assets/images/services/data/data-featu-05.webp"
import features06 from "../../assets/images/services/data/data-featu-06.webp"
import features07 from "../../assets/images/services/data/data-featu-07.webp"
import features08 from "../../assets/images/services/data/data-featu-08.webp"

const DataLossPreventionData = {
    "BannerData":[
        {
            "title": "Robust <span>Data Loss <br/>Prevention</span><br/> Solutions",
            "bannerBtnText": 'Let’s Connect',
            "bannerBigimg" : `${banImg1}`,
            "bannerAlt": 'Android App Development',
        },
    ],

    "Introduction":[
        {
            "introContent" :`Our Data Loss Prevention (DLP) service empowers organizations to safeguard their sensitive data and prevent unauthorized access or leaks. With a proactive approach to data protection, we help you identify, monitor, and mitigate risks across your digital ecosystem. From compliance requirements to insider threats, our comprehensive DLP solutions ensure data integrity and confidentiality.`,
            "introImg": `${banImg2}`,
            "brochurelink": "/",
        }
    ],

    "ServiceBenifits" : [
        {   
            "benifitCont" : "Protect classified sensitive data from leaks, breaches, theft and loss",
        },
        {
            "benifitCont" : "Ensure compliance with regulatory requirements",
        },
        {
            "benifitCont" : "Detect and respond to insider threats and malicious activities",
        },
        {
            "benifitCont" : "Minimize business disruption and financial losses",
        },
        {
            "benifitCont" : "Build customer trust with robust data protection measures",
        },
        {
            "benifitCont" : "Gain visibility and control over data across your organization",
        },
        // {
        //     "benifitCont" : "Receive proactive support and updates for evolving threats",
        // },
    ],

    "FeaturesServices":[
        {
          
            "featureDescriptiom":"Automated data discovery and classification",
            "FeatImg" : `${features01}`,
            "FeatImgAltTag" : "Native Android Apps",
            
        },
        {
            
            "featureDescriptiom":"Real-time monitoring and policy enforcement",
            "FeatImg" : `${features02}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Endpoint level data encryption capabilities",
            "FeatImg" : `${features03}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"User activity tracking and behavioral analytics",
            "FeatImg" : `${features04}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Incident response and threat remediation",
            "FeatImg" : `${features05}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Integration with SIEM and security tools",
            "FeatImg" : `${features06}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Compliance reporting and audit trails",
            "FeatImg" : `${features07}`,
            "FeatImgAltTag" : "Web Apps",
        },
        {
            
            "featureDescriptiom":"Customizable policies for data protection",
            "FeatImg" : `${features08}`,
            "FeatImgAltTag" : "Web Apps",
        },
       
    ],


    "FooterCtaSection":[
        {
            "CtaDescriptiom":"Secure your data assets with proactive DLP solutions. Contact us today to schedule a consultation and learn how our Data Loss Prevention service can safeguard your business.",
            "CtaBtnText": 'Let’s Connect',
            "CtaBtnLink": '/get-a-quote',
        },
    ],


    
} 

export default DataLossPreventionData